import { useCallback, useState } from 'react';
import { ascending, descending } from '../../constants/sortDirections';
import { sortBy } from '../../services/sort-service';
import { useLocale } from '../../intl/hooks';
import { FulfillmentPlanOrderGridStatus } from '../../enums/fulfillmentplan-order-grid-status';
import { itemsTableColumnIds } from './items-table-column-definitions';
import { useIntl } from 'react-intl';

export const useSortItemsTable = (setTableData, fulfillmentPlans) => {
  const [sortState, setSortState] = useState({
    column: itemsTableColumnIds.fulfillmentPlanId,
    direction: ascending,
  });
  const { locale } = useLocale();
  const intl = useIntl();

  const sort = useCallback(
    (columnId) => {
      const sortOptions = {};

      setSortState(({ column: prevColumn, direction: prevDirection }) => {
        const newSortDirection = prevColumn === columnId && prevDirection === ascending ? descending : ascending;

        sortOptions.direction = newSortDirection;

        return { column: columnId, direction: newSortDirection };
      });

      setTableData((prevState) => {
        const newState = [...prevState];
        if (columnId === itemsTableColumnIds.fulfillmentPlanId) {
          newState.sort((a, b) => {
            const indexOfA = fulfillmentPlans.findIndex((x) => x.fulfillmentPlanId === a.fulfillmentPlanId);
            const indexOfB = fulfillmentPlans.findIndex((x) => x.fulfillmentPlanId === b.fulfillmentPlanId);

            return sortBy(sortOptions)(indexOfA, indexOfB);
          });
        } else if (columnId === itemsTableColumnIds.status) {
          sortOptions.intlCollator = new Intl.Collator(locale);

          newState.sort((a, b) => {
            const fulfillmentPlanA = fulfillmentPlans.find((x) => x.fulfillmentPlanId === a.fulfillmentPlanId);
            const fulfillmentPlanB = fulfillmentPlans.find((x) => x.fulfillmentPlanId === b.fulfillmentPlanId);

            const translationA = intl.formatMessage(FulfillmentPlanOrderGridStatus[fulfillmentPlanA.orderGridStatus].translation);
            const translationB = intl.formatMessage(FulfillmentPlanOrderGridStatus[fulfillmentPlanB.orderGridStatus].translation);

            return sortBy(sortOptions)(translationA, translationB);
          });
        } else {
          sortOptions.intlCollator = new Intl.Collator(locale);
          sortOptions.propName = columnId;

          newState.sort(sortBy(sortOptions));
        }

        return newState;
      });
    },
    [setTableData, fulfillmentPlans, locale, intl],
  );

  return { sort, sortState };
};
